﻿import i18n from "@/i18n";

export const booleanToYesNoString = (value: boolean | undefined): string => {
  return value ? i18n.global.t("shared.yes") : i18n.global.t("shared.no");
};
